import { ComponentMap } from '@cinch-nx/data-storyblok'
import { globalStoryblokComponents } from '@cinch-nx/storyblok'
import Video from '../video/video'
import {
  AuthorByline,
  CtaButton,
  FaqSection,
  FeatureCard,
  FeatureImageCard,
  HeroCtaButton,
  HighlightsSection,
  IntroSection,
  TextInlineImage,
  TextInlineImageSection,
} from './blocks'

export const landingStoryblokComponents: ComponentMap = {
  ...globalStoryblokComponents,
  AuthorByline,
  CtaButton,
  FaqSection,
  FeatureCard,
  FeatureImageCard,
  HeroCtaButton,
  HighlightsSection,
  IntroSection,
  LandingTextInlineImage: TextInlineImage,
  LandingTextInlineImageSection: TextInlineImageSection,
  YoutubeVideo: Video,
}
